import type { IColumnInfo } from '@dbl/core/dataSource';

// eslint-disable-next-line @typescript-eslint/naming-convention
export const SortableItems = 'sortable-items';
// eslint-disable-next-line @typescript-eslint/naming-convention
export const OptionPageSize = 1000;
export const STRING_OPTION_PAGE_SIZE = 1000; // 应后端小刚要求, 10000改成1000
export const ALL_VALUE = '255';
export const ALL_UNIQUE_VALUE = '255';
export const ALL_SUM_VALUE = 'all-sum';

// AB实验事件筛选用（仅用于AB实验全局筛选numeric类型和事件筛选数值下拉选）
export const EventFilterNumberOptions = [
  {
    value: 'greater',
    text: '>',
    text_en: '>',
  },
  {
    value: 'greaterOrEqual',
    text: '≥',
    text_en: '≥',
  },
  {
    value: 'less',
    text: '<',
    text_en: '<',
  },
  {
    value: 'lessOrEqual',
    text: '≤',
    text_en: '≤',
  },
  {
    value: 'equal',
    text: '=',
    text_en: '=',
  },
  {
    value: 'between',
    text: '区间',
    text_en: 'Between',
  }
];

// AB实验事件筛选用（仅用于AB实验全局筛选text类型）
export const EventFilterTextOptions = [
  {
    value: 'equal',
    text: '等于',
    text_en: 'Equal',
  },
  {
    value: 'notEqual',
    text: '不等于',
    text_en: 'Not equal',
  },
  {
    value: 'contains',
    text: '包含',
    text_en: 'Contains',
  },
  {
    value: 'notContains',
    text: '不包含',
    text_en: 'Not contains',
  },
  {
    value: 'startsWith',
    text: '开头为',
    text_en: 'Starts with',
  },
  {
    value: 'endsWith',
    text: '结尾为',
    text_en: 'Ends with',
  },
  {
    value: 'in',
    text: '包含任意',
    text_en: 'In',
  },
  {
    value: 'notIn',
    text: '不包含任意',
    text_en: 'Not in',
  }
];

export type TDispatchFun = (path: string, payload: {}, callback?: Function) => void;
export type TItemOnChange = (columnInfo: IColumnInfo, isUpdate?: boolean) => void;
